module.exports = __webpack_public_path__ + "static/media/pm_square_workflow.5faab8e3.svg";